import en from './en.messages';
import { flatten } from './flatten';
import fr from './fr.messages';
import { MessageKeyValue } from './types';

export * from './types';

export const userLocale = navigator.language.toLowerCase().split(/[_-]+/)[0];

const translationMessages: MessageKeyValue = {
  en: flatten(en),
  fr: flatten(fr),
};

export default translationMessages;
